import { render, staticRenderFns } from "./OrderBatchCreate.vue?vue&type=template&id=268e7f14&lang=pug&"
import script from "./OrderBatchCreate.vue?vue&type=script&lang=js&"
export * from "./OrderBatchCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports